/*
 * File: c:\Users\j.mazat\Desktop\Moby\MobyFleet\mobyfleet_frontoffice\src\Content\Car\Pricing\SliderPricingMUI.tsx
 * Project: c:\Users\j.mazat\Desktop\Moby\MobyFleet\mobyfleet_frontoffice
 * Created Date: Tuesday August 27th 2024
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Tuesday August 27th 2024 2:23:42 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2024 Autobuy SAS
 * -----
 */

import { Slider } from "@mui/material";
import { getThemeColor } from "Utils/ThemeColor";

type SliderMUIProps = {
    themeColor: string,
    setter: Function,
    value: number,
    min: number,
    max: number,
    marks: {
        value: number;
        label: string;
    }[]
};

export default function SliderPricingMUI(props: SliderMUIProps) {
    const themeColor = getThemeColor(props.themeColor);

    return (
        <Slider
            style={{color: themeColor}}
            value={props.value}
            marks={props.marks}
            min={props.min}
            max={props.max}
            onChange={(e, value) => props.setter(value as number)}
            step={null}
        />
    );
};
